import NavBar from "../../Componants/NavBar";
import React, {useEffect, useState} from 'react';
import AlertError from "../../Componants/AlertError";
import {useNavigate} from "react-router-dom";
import {Ajax} from "../../Service/ajax";
import OrganisationCard from "../../Componants/Organisation/OrganisationCard";
import TableOrganisation from "../../Componants/Organisation/TableOrganisation";
import {GridLoader} from "react-spinners";
import AlertSuccess from "../../Componants/AlertSuccess";
import Footer from "../../Componants/Footer";
import SubscriptionOption from "../../Componants/SubscriptionOption";
import {plans, security} from "../../env/Environment";
import Swal from "sweetalert2";

export default function BsHomeView(){
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const errorInSession = sessionStorage.getItem('error');
    const session = sessionStorage.getItem("session");
    const trf = sessionStorage.getItem("trf");
    const solution = JSON.parse(sessionStorage.getItem("solution"));
    const [companies,setCompanies] = useState([]);
    const success = sessionStorage.getItem("success");
    const [client_trf, setClient_trf] = useState({});
    const [isEnable, setIsEnable] = useState(true);


    const filterAndSortData = (data, limit) => {
        // Trier la liste en ordre croissant (du plus ancien au plus récent)
        const sortedData = data.sort((a, b) => new Date(a.createAt) - new Date(b.createAt));

        // Retourner seulement le nombre d'éléments demandé
        return sortedData.slice(0, limit);
    };

    useEffect(() => {
        const fetchData = async (trf_id) => {
            try {
                setLoading(true);
                const clientSub = await Ajax.getRequest(`/api/v1/sub/subscription/client/organisation/${JSON.parse(trf).application.organisationId}`);
                let isActive ;
                isActive = JSON.parse(trf).status === "ACTIVE";
                const {data} = await Ajax.getRequest(`/api/v1/usr/companies?cat=all&sol=${solution.id}&slug=&pge=1&lmt=100`)
                const filteredData = filterAndSortData(data.contents, 1);
                if(filteredData.length > 0){
                    setIsEnable(false);
                }
                sessionStorage.setItem("companies",JSON.stringify(filteredData.map(item => ({ id: item.id, name: item.name, category:item.category.name, certified:item.certified, enabled:item.enabled, description:item.description }))));
                setClient_trf(clientSub.data.object);
                let company = JSON.parse(sessionStorage.getItem("companies"));
                setCompanies(company)

            } catch (error) {
                navigate("/error-page", { state: { errorCode: error.response.status } });
            } finally {
                setLoading(false);
            }
        };
        if (session && trf) {
            fetchData(JSON.parse(trf).id);
        }else{
            navigate('/');
        }
    }, []);
    return(
        <>
            {loading ? (
                <div className="loading-overlay">
                    <div className="loading-spinner">
                        <GridLoader
                            color="#debf66"
                            loading
                            size={15}
                        />
                    </div>
                </div>
            ) : (
                <div className="layout-wrapper layout-content-navbar layout-without-menu">
                    <div className="layout-container">
                            <div className="layout-page">
                                <NavBar route={"Particulier"}/>
                                <div className="content-wrapper">
                                    <div className="container-xxl flex-grow-1 container-p-y">
                                        {errorInSession && <AlertError/>}
                                        {success && <AlertSuccess/>}
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <OrganisationCard title={"BIENVENUE | KARIBU | WELCOME"}
                                                                  subtitle={"Bienvenu sur le portail Business de Netikash Subscribe. Ici vous allez créer et gérer tous vos services d’abonnement."} isEnable={isEnable}/>
                                            </div>
                                            <div className="col-lg-2 col-sm-6 mb-4">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between">
                                                            <div className="card-info">
                                                                <p className="card-text">Organisations</p>
                                                                <div className="d-flex align-items-end mb-2">
                                                                    <h2 className="card-title mb-0 me-2">{companies.length}</h2>
                                                                </div>
                                                                <small className={"mb-1"}>netikash subscribe</small>
                                                            </div>
                                                            <div className="card-icon">
            <span className="badge bg-label-primary rounded p-2">
              <i className="bx bx-trending-up bx-sm"></i>
            </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-sm-6 mb-4">
                                                <SubscriptionOption title={client_trf.title} status={client_trf.status} end={client_trf.endDate} start={client_trf.startDate}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <TableOrganisation title={"Organisations"} content={companies}/>
                                        </div>
                                    </div>
                                    <div className="content-backdrop fade"></div>
                                </div>
                                <Footer/>
                            </div>
                    </div>
                </div>
            )
            }
        </>
    )
        ;
}
